import {Modal, Tooltip} from 'bootstrap';
import _map from "lodash/map";
import _each from "lodash/each";
import _isArray from "lodash/isArray";
import _unescape from 'lodash/unescape';
import {initDatepickersForParent} from './datepicker';

require('datatables.net');
require('datatables.net-responsive');

const initDatatables = function (selector) {
    const dom = '<"dataTable-info row"<"col-12 col-sm-6"i><"col-12 col-sm-6 text-end"l>><"overflow-auto" rt><"datatable-footer bottom flex-end"p><"clear">';
    const language = {
        infoFiltered: "",
        info: window.config.language.filter.info,
        infoEmpty: window.config.language.filter.infoEmpty,
        lengthMenu: window.config.language.filter.lengthMenu,
        zeroRecords: window.config.language.filter.zeroRecords,
        paginate: {
            next: "<i class=\"vertical-align-middle far fa-arrow-right\"></i>",
            previous: "<i class=\"vertical-align-middle far fa-arrow-left\"></i>"
        }
    };
    let filterState = false;
    let searchBarState = false;
    let activeFilterList = [];

    selector.find('.datatable.datatable-api').each(function () {
        const table = $(this);
        const wrapper = $(this).closest('.datatable-filter-wrapper');
        const url = table.data('url');

        let visibility = [];

        const modalWrap = document.createElement('div');
        modalWrap.id = 'modalWrap-' + $(this).attr('id');
        $('body').append(modalWrap);

        const columnData = JSON.parse(_unescape(table.data('columnDefinitions')));

        const buildHtml = function (action, additionalText) {
            let html = '';

            const icon = (additionalText ? additionalText + ' ' : '') + `<i class="${action.icon.type} fa-${action.icon.class}" aria-label="${action.tooltip}"></i>`;

            if (action.confirmable) {
                // now we need to create a button with a modal
                if (action.ajaxModal ?? false) {
                    html += `<a href="#" class="modalActionBtn p-2 m-1 ${action.openOnLoad == false ? '' : ' modal-open-on-load-btn'}" data-action="${action.modal.id}" data-method="${action.ajaxMethod ?? 'get'}" data-route="${action.route}">${icon}</a>`;
                } else {
                    html += `<a href="#" class="modalActionBtn p-2 m-1" data-action="${action.modal.id}">${icon}</a>`;
                }
                if (modalWrap.querySelectorAll(`.modal.${action.modal.id}`).length === 0) {
                    const modal = document.createElement('div');
                    modal.innerHTML = action.modal.content;
                    modalWrap.append(modal);
                }
            } else {
                html += `<a href="${action.route ?? '#'}" ${action.additionalParameters ?? ''} class="p-2 m-1">${icon}</a>`;
            }

            if (action.hasOwnProperty('tooltip') && action.tooltip) {
                return `<span title="${action.tooltip}" data-bs-toggle="tooltip" data-bs-placement="top">${html}</span>`
            }

            return html;
        }

        const columns = _map(columnData, (column, columnIndex) => {
            column.render = function (data, type, row) {
                if (column.hasOwnProperty('hideIfNoDataIsAvailable') && column.hideIfNoDataIsAvailable && (data === null || data.length === 0)) {
                    visibility[columnIndex] = visibility[columnIndex] ?? false;
                } else {
                    visibility[columnIndex] = true;
                }

                if (column.hasOwnProperty('withActions') && column.withActions) {
                    let html = "";

                    data.forEach(function (action) {
                        html += buildHtml(action);
                    });

                    return html;
                } else if (data && data.hasOwnProperty('action')) {
                    // when column has a dedicated action, wrap column content with this action
                    return buildHtml(data.action, data.value);
                }

                return data;
            };

            return column;
        });

        let createdTable = $.fn.dataTable.isDataTable(table) ? table.DataTable() : table.DataTable({
            deferLoading: true,
            responsive: true,
            serverSide: true,
            autoWidth: true,
            ajax: url,
            columns: columns,
            order: table.data('sortingDefinitions') === '[]' || _isArray(table.data('sortingDefinitions')) ? [] : JSON.parse(_unescape(table.data('sortingDefinitions'))),
            dom: dom,
            language: language,
            lengthMenu: table.data('lengthMenu') ?? [[10, 25, 50], [10, 25, 50]],
        });

        createdTable.on('preXhr.dt', (e) => {
            e.target.closest('.is-data-table__holder').querySelector('.is-data-table__loader').classList.remove('d-none');
        });

        createdTable.on('xhr', () => {
            modalWrap.innerHTML = '';
            visibility = [];
        });

        const divEmpty = $('#' + $(this).attr('id') + '_empty_hint');

        const drawTooltips = function () {
            $(this).find('[data-bs-toggle="tooltip"]').each(function () {
                new Tooltip(this, {
                    boundary: document.body // or document.querySelector('#boundary')
                });
            })
        }

        const filterElements = $('div.datatable-filter');

        // initialize search values for each column and draw deferLoaded table
        filterElements.find('select:not([data-ignore-datatable]), input:not([data-ignore-datatable])').each(function () {
            let me = $(this);
            createdTable.column(me.closest('div.datatable-filter').data('column')).search(me.val());
        });

        createdTable.draw();

        const checkIfSearchOrFilter = function () {
            if ($('.filter-search', wrapper).val() !== '') {
                return true;
            }

            return filterElements.find('select:not([data-ignore-datatable]), input:not([data-ignore-datatable])').filter(function () {
                return $(this).val() !== ''
            }).length > 0;
        }

        createdTable.on('draw', function (e, settings) {
            // when the datatable is filtered, hide div empty
            if (checkIfSearchOrFilter()) {
                divEmpty.addClass('d-none');
            } else {
                divEmpty.toggleClass('d-none', !(divEmpty.length > 0 && createdTable.rows().count() < 1));
            }

            _each(visibility, (visible, index) => {
                createdTable.column(index).visible(visible);
            });

            if (divEmpty.length > 0) {
                divEmpty.toggleClass('d-none', createdTable.rows().count() > 0);
            }

            // remove loader if table is complete
            e.target.closest('.is-data-table__holder').querySelector('.is-data-table__loader').classList.add('d-none');

            if(createdTable.page.info().pages <= 1) {

                $( createdTable.tables().footer() ).find('.dataTables_paginate').addClass( 'd-none' );
            } else {
                $( createdTable.tables().footer() ).find('.dataTables_paginate').removeClass( 'd-none' );
            }

        });

        createdTable.on('draw responsive-display', drawTooltips);

        $('div.dataTables_length select:not([data-ignore-datatable])', wrapper).addClass('form-select');




        function updateFilterEl(target) {
            activeFilterList.forEach((el) => {
                if(el.id === target.id) {
                    el.value = target.value
                }
            })
        }

        function deleteFilterEl(target) {
            activeFilterList.forEach((el, index, arr) => {
                if (el.id === target.id) {
                    arr.splice(index, 1)
                }
            });
        }

        function addFilterEl(target) {
            activeFilterList.push({
                id: target.id,
                value: target.value
            })
        }

        function handleButtonState() {
            const filterButton = $('.apply-filter');

            if(activeFilterList.length) {
                filterState = true

                // Enable Filter Button
                filterButton.prop('disabled', false);
                $('.reset').prop('disabled', false);

            } else {
                filterState = false

                // Disable Filter Button
                if(!searchBarState) {
                     filterButton.prop('disabled', true);
                     $('.reset').prop('disabled', true);
                     $('.reset-search').prop('disabled', true);
                }
            }
        }

        filterElements.find('select:not([data-ignore-datatable]), input:not([data-ignore-datatable])').on('change', (e) => {

            if (e.handled !== true) { // Avoid firing event twice
                e.handled = true;

                // If field has value
                if (e.target.value.length > 0) {
                    // If object doesn't exist in array, add it
                    if(!activeFilterList.find((obj) => obj.id === e.currentTarget.id)) {
                        addFilterEl(e.currentTarget);
                    } else { // If object exist add current value
                        updateFilterEl(e.currentTarget);
                    }

                } else {
                    deleteFilterEl(e.currentTarget);
                }

                handleButtonState();

            }
        })


        $('.filter-search', wrapper).on('keyup', function () {
            if ($(this).val().length > 0) {
                searchBarState = true;
                $('.apply-filter', wrapper).prop('disabled', false);
                $('.reset').prop('disabled', false);
                $('.reset-search').prop('disabled', false);
            } else {
                searchBarState = false;
                if(!filterState) {
                    $('.apply-filter', wrapper).prop('disabled', true);
                    $('.reset').prop('disabled', true);
                    $('.reset-search').prop('disabled', true);
                }
            }
        });

        $('.reset', wrapper).click(function () {
            activeFilterList = [];
            searchBarState = false;
            filterElements.find('select:not([data-ignore-datatable]), input:not([data-ignore-datatable]), input[role="datepicker"]').each(function () {
                $(this).val('');
                this.dispatchEvent(new Event('change'));
            });
            $('.filter-search', wrapper).val('');
            $('.apply-filter', wrapper).click();

            handleButtonState();
        })

        $('.reset-search', wrapper).click(function () {
            searchBarState = false;
            $('.filter-search', wrapper).val('');
            $('.apply-filter', wrapper).click();

            handleButtonState();
        })

        $('.apply-filter', wrapper).on('click', function () {
            const searchValue = $('.filter-search', wrapper).val();

            createdTable.search(searchValue);

            filterElements.each(function () {
                let me = $(this);
                createdTable.column(me.data('column')).search(me.find('select:not([data-ignore-datatable]), input:not([data-ignore-datatable])').first()?.val());
            })

            createdTable.draw();
        });

        $(table).on('click', '.modalActionBtn', function (e) {
            e.preventDefault();
            const me = $(this);
            const modal = $(`.modal.${me.data('action')}`);
            createModal(me, modal);
        });

        function createModal(me, modal) {
            if (me.data('route')) {
                window.axios[me.data('method') ?? 'get'](me.data('route'))
                    .then(({data: html}) => {
                        modal.find('.ajaxContent').html(html);
                        new Modal(modal[0]).show();
                        initDatepickersForParent(modal);
                    })
                return;
            }

            new Modal(modal[0]).show();
        }

        $(table).on('draw.dt', function () {
            let el = $('.modal-open-on-load-btn');
            if (el.length) {
                const modal = $(`.modal.${el.data('action')}`);
                createModal(el, modal);
            }
        });

    })

    const tableView = selector.find('.datatable.datatable-view');

    tableView.DataTable({
        responsive: true,
        autoWidth: true,
        dom: dom,
        language: language
    });

    const datatableSearchInputs = document.querySelectorAll('.datatable-filter-wrapper .filter-search');
    datatableSearchInputs.forEach(search => {
        search.addEventListener('keyup', function (event) {
            let wrapper = event.target.closest('.datatable-filter-wrapper');
            // on press enter -> apply search
            if (event.keyCode === 13) {
                event.preventDefault();
                let btn = wrapper.querySelector('button.apply-filter');
                btn.removeAttribute('disabled');
                btn.click();
            }
        });
    });

    const datatableFilters = document.querySelectorAll('.datatable-filter-wrapper .datatable-filter select');
    datatableFilters.forEach(filter => {
        filter.addEventListener('change', (event) => {
            event.preventDefault();
            let wrapper = event.target.closest('.datatable-filter-wrapper'),
                btn     = wrapper.querySelector('button.apply-filter');
            btn.removeAttribute('disabled');
            btn.click();
        });
    });

};

$(function () {
    initDatatables($('body'));

    $(document.body).on('show.bs.modal', '.modal', function () {
        window.setTimeout(() => initDatatables($(this)), 20);
    });
});

export {initDatatables};
